<script>
export default {
  name: 'triageBox',
  components: {},
  props: {
    title: {
      type: String,
      isRequired: true,
      default: '',
    },
    hasData: {
      type: Boolean,
      isRequired: false,
      default: true,
    },
    noDataTitle: {
      type: String,
      isRequired: false,
      default: '',
    },
  },
};
</script>
<template>
  <v-container fluid class="rounded-lg relative container-box mx-0">
    <div class="absolute container-box-title">
      {{ title }}
    </div>
    <v-row v-if="hasData" class="mt-1 overflow-auto ch-100 cw-100">
      <div class="cw-100">
        <slot></slot>
      </div>
    </v-row>
    <v-col v-else cols="12" class="text-center grey--text text--darken-3 no-data">
      {{ noDataTitle }} یافت نشد
    </v-col>
  </v-container>
</template>
<style lang="scss" scoped>
.container-box {
  padding-top: 1.5rem;
  position: relative;
  &-title {
    position: absolute;
    padding: 0.05rem 0.2rem;
    background-color: white;
    color: var(--v-secondary-base);
    font-weight: 500;
    top: 0;
    transform: translateY(-50%);
    right: 24px;
    font-size: 15px;
  }
}
.no-data {
  position: absolute;
  top: 50%;
  right: 0;
  left: 0;
}
</style>
